import { connect } from 'react-redux'
import get from 'lodash/get'
import { withRouter } from 'react-router'

import { ListingsContent } from '../components/ListingsContent'
import { setSearchResults, setAirSearchRequest } from '../actions'
import {
  listingsLoadMore,
  listingsFilterCall,
  fetchAirSearchResponse,
  loadSavedFilterInfo,
  setTabDefaultFilters,
} from '../actions/listings'
import {
  displayInfiniteScrollLoadMore,
  updateActiveTabId,
  setOverfilteredStatus,
} from '../actions/listings/actionCreators'
import { fetchFlexDates, fetchExdFlexDates } from '../actions/flexDates'

const mapStateToProps = (state, ownProps) => ({
  activeTabId: get(state, 'activeTabId'),
  airlines: get(state, 'airlines', {}),
  altDeals: get(state, 'listings.altDeals'),
  brandReference: get(state, 'brandReference', []),
  cacheListings: get(state, 'cacheListings', {}),
  calendarPricing: get(state, 'calendarPricing', []),
  calendarPricingExpressDeals: get(state, 'calendarPricingExpressDeals', []),
  calendarPricingMap: get(state, 'calendarPricingMap', {}),
  currentMobileFilter: get(state, 'uiToggles.currentMobileFilter', ''),
  disableLoadingOverlay: state.uiToggles.loadingOverlay,
  displayAds:
    state.pclnBootstrapData?.features?.whiteLabel?.adsEnabled &&
    get(state, 'uiToggles.displayAds', true),
  displayInfiniteScrollLoadMore: state.displayInfiniteScrollLoadMore,
  fetchedInitialListings: state.fetchedInitialListings,
  filterValues: state.filterInfo,
  hasExpressDeal: get(state, 'flags.hasExpressDeal'),
  history: ownProps.history,
  listings: state.listings,
  listingsHasErrored: state.listingsHasErrored,
  listingsIsLoading: state.listingsIsLoading,
  listingsLoadingMessage: state.listingsLoadingMessage,
  listingsMetaData: get(state, 'listingsMetaData', {}),
  pclnBootstrapData: state.pclnBootstrapData,
  priceBreakers: state?.priceBreakers,
  SETI: get(state, 'pclnBootstrapData.requestLocals.seti', []),
  slices: get(state, 'listings.response.rawResponse.slice'),
  attributeFilterConditions: ownProps.attributeFilterConditions,
})

const mapDispatchToProps = dispatch => ({
  setSearchResults: () => dispatch(setSearchResults()),
  setAirSearchRequest: () => dispatch(setAirSearchRequest()),
  fetchAirSearchResponse: (
    pclBootstrapData,
    seti,
    airSearchPromise,
    attributeFilterConditions
  ) =>
    dispatch(
      fetchAirSearchResponse(
        pclBootstrapData,
        seti,
        airSearchPromise,
        attributeFilterConditions
      )
    ),
  loadSavedFilterInfo: ({ tabId }) => dispatch(loadSavedFilterInfo({ tabId })),
  setTabDefaultFilters: ({ tabId }) =>
    dispatch(setTabDefaultFilters({ tabId })),
  listingsLoadMore: (pclBootstrapData, seti, filters) =>
    dispatch(listingsLoadMore(pclBootstrapData, seti, filters)),
  listingsFilterCall: (pclnBootstrapData, displayType) =>
    dispatch(listingsFilterCall(pclnBootstrapData, displayType)),
  setDisplayInfiniteScrollLoadMore: bool =>
    dispatch(displayInfiniteScrollLoadMore(bool)),
  fetchFlexDates: (searchRequest, tripType, sopqEnabled) =>
    dispatch(fetchFlexDates(searchRequest, tripType, sopqEnabled)),
  updateActiveTabId: activeTabId => dispatch(updateActiveTabId(activeTabId)),
  setOverfilteredStatus: overfilteredStatus =>
    dispatch(setOverfilteredStatus(overfilteredStatus)),
  fetchExdFlexDates: (searchRequest, tripType) =>
    dispatch(fetchExdFlexDates(searchRequest, tripType)),
})

const ListingsContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(ListingsContent)

const ListingsContentContainer = withRouter(ListingsContainer)

export { ListingsContentContainer }
